import React from "react";

import { IconName } from "../types";
import Icon from "./Icon";

const MoreDetailsBtn = (props: {
  preventDefault?: boolean;
  onClick: () => void;
  title?: string;
}) => {
  const onClick = (e: React.MouseEvent<HTMLElement>) => {
    if (props.preventDefault) {
      e.preventDefault();
      e.stopPropagation();
    }
    props.onClick();
  };
  return (
    <div className={"pyht-more-details-btn"} role={"button"} onClick={onClick}>
      {props.title ? props.title : "More Details"}{" "}
      <Icon name={IconName.ARROW_THIN} />
    </div>
  );
};

export default MoreDetailsBtn;
